import { API_ENDPOINTS } from "../constants/api";
import { TOKEN_API } from "../constants/enviroment";

export interface AccountContextResult {
  isMember: boolean;
  isAgency: boolean;
  isManagedClient: boolean;
  /** Owner's auth user id — use for brands/prompts/scores (same as current user when role is owner). */
  accountId: string | null;
}

interface AccountApiResponse {
  owner_id: string;
  role: string;
  is_agency: boolean;
  is_managed_client: boolean;
}

/**
 * Resolves team membership and the user_id that owns shared data (brands row owner).
 * Do not use users_meta.account_id for this — it is accounts.accounts.id (UUID), not auth user id.
 */
export async function fetchAccountContext(userId: string): Promise<AccountContextResult> {
  if (!TOKEN_API) {
    console.warn('[fetchAccountContext] TOKEN_API is empty — skipping API call, returning isMember=false');
    return { isMember: false, isAgency: false, isManagedClient: false, accountId: null };
  }
  const url = `${API_ENDPOINTS.account}?user_id=${encodeURIComponent(userId)}`;
  try {
    const res = await fetch(url, {
      headers: { Authorization: `Bearer ${TOKEN_API}` },
    });
    if (res.status === 404) {
      console.warn('[fetchAccountContext] 404 — user not found in account_members');
      return { isMember: false, isAgency: false, isManagedClient: false, accountId: null };
    }
    if (!res.ok) {
      return { isMember: false, isAgency: false, isManagedClient: false, accountId: null };
    }
    const body = (await res.json()) as AccountApiResponse;
    const ownerId = body.owner_id;
    const role = body.role;
    if (!ownerId) {
      console.warn('[fetchAccountContext] owner_id is empty — returning isMember=false');
      return { isMember: false, isAgency: false, isManagedClient: false, accountId: null };
    }
    const result = {
      isMember: role === "member",
      isAgency: body.is_agency === true,
      isManagedClient: body.is_managed_client === true,
      accountId: ownerId,
    };
    return result;
  } catch (err) {
    console.error('[fetchAccountContext] CAUGHT ERROR — returning isMember=false:', err);
    return { isMember: false, isAgency: false, isManagedClient: false, accountId: null };
  }
}

